module.exports = __webpack_public_path__ + "img/ticio.2b684280.png";